// Borrowed from Campaign Client
export const getCookie = (name) => {
  // Split cookie string and get all individual name=value pairs in an array
  const cookieArr = document.cookie.split(";");

  // Loop through the array elements
  for (let i = 0; i < cookieArr.length; i++) {
    const cookiePair = cookieArr[i].split("=");

    /* Removing whitespace at the beginning of the cookie name
    and compare it with the given string */
    if (name == cookiePair[0].trim()) {
      // Decode the cookie value and return

      let value = decodeURIComponent(cookiePair[1])
      if (name === 'x-auth-token' && window.sessionStorage) {
        sessionStorage.setItem('x-auth-token', value);
      }

      return value;
    }
  }

  // Return null if not found
  return null;
};

export const setCookie = (name, value, options = {}) => {

  const defaultOptions = {
    path: '/',
    domain: window.location.hostname.includes('.') ? '.' + window.location.hostname.split('.').slice(-2).join('.') : window.location.hostname, // Handle subdomains
    secure: window.location.protocol === 'https:',
    sameSite: 'Lax',
  };

  const opts = { ...defaultOptions, ...options };

  let cookieString = `${name}=${encodeURIComponent(value)}`;

  if (opts.domain) cookieString += `; domain=${opts.domain}`;
  if (opts.path) cookieString += `; path=${opts.path}`;
  if (opts.expires) cookieString += `; expires=${opts.expires}`;
  if (opts.maxAge) cookieString += `; max-age=${opts.maxAge}`;
  if (opts.secure) cookieString += '; secure';
  if (opts.sameSite) cookieString += `; samesite=${opts.sameSite}`;

  if (name === 'x-auth-token' && window.sessionStorage) {
    sessionStorage.setItem('x-auth-token', value);
  }

  document.cookie = cookieString;
};

export const deleteCookie = (name, options = {}) => {
  window.sessionStorage.clear();
  const defaultOptions = {
    path: '/',
    domain: window.location.hostname.includes('.') ? '.' + window.location.hostname.split('.').slice(-2).join('.') : window.location.hostname,
  };

  const opts = { ...defaultOptions, ...options };

  // Set expiration to past date to delete the cookie
  setCookie(name, '', { ...opts, expires: 'Thu, 01 Jan 1970 00:00:00 GMT' });
};
